import type * as Types from '@trello/graphql/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type { tag } from '@trello/utility-types';
import * as Apollo from '@apollo/client';
import process from 'process';
export type __OpaqueBrandRef = typeof tag;
export type CurrentWorkspacePaidStatusFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'offering'>
  & { credits: Array<(
    { __typename: 'Credit' }
    & Pick<Types.Credit, 'id' | 'type' | 'via'>
  )> }
);

export const CurrentWorkspacePaidStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CurrentWorkspacePaidStatus' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'via' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentWorkspacePaidStatusFragment, unknown>;

interface UseCurrentWorkspacePaidStatusFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      CurrentWorkspacePaidStatusFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: (Apollo.StoreObject | Apollo.Reference) | null;
  returnPartialData?: boolean;
}

interface UseCurrentWorkspacePaidStatusFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<CurrentWorkspacePaidStatusFragment>,
    'data'
  > {
  data?: CurrentWorkspacePaidStatusFragment;
}

export const useCurrentWorkspacePaidStatusFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCurrentWorkspacePaidStatusFragmentOptions): UseCurrentWorkspacePaidStatusFragmentResult => {
  const result = Apollo.useFragment<CurrentWorkspacePaidStatusFragment>({
    ...options,
    fragment: CurrentWorkspacePaidStatusFragmentDoc,
    fragmentName: 'CurrentWorkspacePaidStatus',
    from:
      !from || !(from as Apollo.StoreObject)?.id
        ? null
        : { __typename: 'Organization', ...from },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CurrentWorkspacePaidStatusFragment };
};
